module.exports = __webpack_public_path__ + "static/img/20221201_01.31540fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221201_01.png
// module id = f+TZ
// module chunks = 0